<template>
  <div class="kami-charge">
    <div class="kami-charge-dialog">
      <div class="kami-charge-header">
        <div class="f18 white">购买VIP权益包</div>
        <div class="kami-charge-header-side">
          <img
            class="kami-charge-close"
            src="/static/images/view_btn_close_white.png"
            alt=""
            @click="close"
          />
        </div>
      </div>
      <template v-if="step === 1">
        <div class="kami-charge-body">
          <div class="kami-charge-part1" v-if="productInfo">
            <div class="kami-charge-title">
              <span class="f16 fb grey3">VIP权益包</span>
              <span class="grey6"
                >（购买后，有效期内该练习包内的练习不限次数，支持实时评分及查看报告解析）</span
              >
            </div>
            <div class="kami-charge-section">
              <div class="kami-charge-item">
                <div class="kami-charge-item-left">
                  <p class="f16 grey3">{{ productInfo.productName }}</p>
                  <p class="f12" v-if="productInfo.aliasName">
                    ({{ productInfo.aliasName }})
                  </p>
                </div>
                <div class="kami-charge-item-right">
                  ￥ <span> {{ productInfo.productPrice || '' }}</span>
                </div>
                <div class="kami-charge-item-button" @click="pay">找家长支付</div>
              </div>
              <div class="kami-charge-tip">{{ productInfo.activityType }}</div>
            </div>
          </div>
          <div class="kami-charge-part2">
            <div class="kami-charge-title">
              <span class="f16 fb grey3">VIP会员</span>
              <span class="grey6">（活动期间购买VIP会员赠送练习包VIP权益包）</span>
            </div>
            <div class="kami-charge-section" ref="vipref">
              <div class="kami-charge-item" v-for="product in productList" :key="product.id">
                <div class="kami-charge-item-left">
                  <p class="f16 grey3">{{ product.time }}</p>
                </div>
                <div class="kami-charge-item-right">
                  ￥ <span> {{ product.total }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kami-charge-bottom" :style="{ width: width }">
          <label @click="vip"></label>
        </div>
      </template> 
      <div class="kami-charge-body" v-else>
        <div class="qrcode-box" ref='qrcode-box' style='padding-top: 30px'>
          <div ref='qrcodeDom'></div>
          <div class="down-qr-btn" @click='downloadQR'>
            <i class="el-icon-download"></i>
            <span>下载二维码</span>
          </div>
          <div class="copy-qr-btn">
            <span>{{ url }}</span>
            <span class="copy" @click='copyQrUrl'>复制</span>
          </div>
          <div class="tip-txt">请下载二维码或复制链接分享给家长，完成升级</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductList,
  getSingleHolidayWork,
  checkHolidayStatusForStudent
} from '@/api/index'
import QRCode from 'qrcodejs2'
import copy from '@/util/copy.js'

export default {
  props: ['activityId', 'holidayTaskId', 'countryId', 'studentId', 'studentName'],
  data() {
    return {
      step: 1,
      width: 'calc(100% - 60px)',
      productInfo: null,
      payInfo: {
        jdcpIP: localStorage.getItem('cpUrl'),
        student_id: this.studentId,
        student_name: this.studentName,
        from: 'web',
        channel: 'wx_pub_qr',
        subject: 'VIP权益包费用', // 诚哥说写死
        body: 'VIP权益包' // 诚哥说写死
      },
      productList: [],
      url: `${localStorage.getItem(
        'pcpUrl'
      )}/m/vip/index.html?studentId=${localStorage.getItem(
        'studentId'
      )}&cpUrl=${localStorage.getItem('cpUrl')}&from=web`
    }
  },
  created() {
    this.getWork()
    this.getVipList()
  },
  mounted() {
    this.$nextTick(() => {
      this.width = this.$refs.vipref.offsetWidth + 'px'
    })
  },
  methods: {
    downloadQR() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$refs['qrcode-box'].querySelector('img').src
      link.setAttribute('download', '找家升级二维码')
      document.body.appendChild(link)
      this.downFlag = false
      link.click()
      link.remove()
    },
    copyQrUrl() {
      copy(this.url).then(() => {
        this.$toast({
          text: '复制成功',
          showWrap: false,
          iconFlag: false,
          duration: 1000,
          styleObj: {
            width: '140px',
            height: '50px',
            'border-radius': '4px',
            'background-color': 'rgba(0, 0, 0, 0.6)',
          },
        })
      })
    },
    close() {
      this.$destroy()
      this.$el.parentElement.removeChild(this.$el)
    },
    vip() {
      this.callback()
      this.close()
    },
    pay() {
      // this.callback('onlyShowQrcode')
      checkHolidayStatusForStudent({
        holidayTaskId: this.holidayTaskId
      }).then(res => {
        if (+res.status === 1) {
          this.step = 2
          this.$nextTick(() => {
            this.qr = new QRCode(this.$refs.qrcodeDom, {
              text: this.url, // 扫码后页面地址
              width: 180, // 二维码宽度
              height: 180, // 二维码高度
              colorDark: '#000000', // 二维码颜色
              colorLight: '#ffffff', // 背景颜色
              correctLevel: QRCode.CorrectLevel.H, // 校正水准
            })
          })
          // this.callback('onlyShowQrcode')
          // 没过期
          // this.$holidayWorkPay({
          //   payInfo: this.payInfo,
          //   productInfo: this.productInfo
          // }).then(res => {
          //   this.callback('onlyShowQrcode')
          // })
        } else {
          this.callback(res)
          this.close()
        }
      })
    },
    getWork() {
      getSingleHolidayWork({
        activityId: this.activityId
      }).then(res => {
        if (res.status === 1) {
          const _data = res.data
          this.productInfo = _data[0]
          this.payInfo = Object.assign({}, this.payInfo, {
            product_id: _data[0].productId,
            price: _data[0].productPrice,
            product_type: _data[0].productType
          })
        } else {
          this.callback(res)
        }
      })
    },
    getVipList() {
      getProductList(
        {
          productType: '4',
          countryId: this.countryId
        },
        res => {
          if (res.status === 1) {
            res.data.sort((x, y) => {
              return y.productPrice - x.productPrice
            })

            this.productList = res.data.map((product, index) => {
              return {
                id: product.productId,
                total: product.productPrice,
                time: product.productName
              }
            })
          } else {
            this.callback(res)
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.kami-charge {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
}

.kami-charge-dialog {
  position: relative;
  width: 800px;
  border-radius: 6px;
  background-color: #f4f4f4;
  overflow: hidden;
}

.kami-charge-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 64px;
  padding: 0 20px;
  background-image: url('/static/images/ui/charge/ic_tankuang_bg.png'),
    linear-gradient(to right, #fe812f, #ffb800);
}

.kami-charge-header-side {
  position: absolute;
  right: 20px;
  width: 30px;
  height: 30px;
  cursor: pointer;

  .kami-charge-close {
    width: 100%;
    height: 100%;
  }
}

.kami-charge-body {
  height: 422px;
  margin: 20px 10px 30px;
  padding: 0 20px;
  border-bottom: 0;
  overflow-y: auto;
}

.kami-charge-part1 {
  width: 740px;
  margin-bottom: 20px;

  .kami-charge-section {
    position: relative;
    margin-top: 30px !important;

    .kami-charge-item {
      padding-top: 18px !important;
      padding-bottom: 18px !important;
      border-bottom: 0;
    }
  }

  .kami-charge-tip {
    position: absolute;
    top: -16px;
    left: -1px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    background: #ffb403;
    border-radius: 6px 0px 6px 0px;
    color: #fff;
    text-align: center;
  }
}

.kami-charge-part2 {
  width: 740px;
  padding-bottom: 78px;

  .kami-charge-section {
    position: relative;
    min-height: 161px;
    border-bottom: 0 !important;
    border-radius: 4px 4px 0px 0px;
  }
}

.kami-charge-section {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  margin-top: 10px;

  .kami-charge-item {
    display: flex;
    align-items: center;
    padding: 12px 0px 12px 50px;
    margin: 0 30px;
    border-bottom: 1px dashed #ccc;

    &:last-child {
      border-bottom: 0;
    }

    .kami-charge-item-left {
      width: 260px;

      p.f12 {
        margin-top: 6px;
      }
    }

    .kami-charge-item-right {
      color: #fe8828;
      font-size: 22px;

      span {
        color: #fe8828;
        font-size: 22px;
        font-weight: bold;
      }
    }

    .kami-charge-item-button {
      width: 120px;
      height: 34px;
      line-height: 34px;
      background: #fe8828;
      border-radius: 17px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      margin-right: 0;
      margin-left: auto;
      cursor: pointer;
    }
  }
}

.kami-charge-bottom {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 30px;
  height: 78px;
  margin: 0 30px;
  border: 1px solid #e0e0e0;
  border-top: 0;
  background: #fff;

  label {
    width: 233px;
    height: 60px;
    background: url('/static/images/ui/charge/btn_upgrade.png') no-repeat center center;
    cursor: pointer;
  }
}

.kami-charge-body::-webkit-scrollbar {
  width: 4px;
  height: 12px;
}

.kami-charge-body::-webkit-scrollbar-button:vertical {
  display: none;
}

.kami-charge-body::-webkit-scrollbar-track:vertical {
  background-color: black;
}

.kami-charge-body::-webkit-scrollbar-track-piece {
  background: #f4f4f4;
}

.kami-charge-body::-webkit-scrollbar-thumb:vertical {
  background-color: #ccc;
  border-radius: 3px;
}

.kami-charge-body::-webkit-scrollbar-thumb:vertical:hover {
  background-color: #ccc;
}

.kami-charge-body::-webkit-scrollbar-resizer:vertical {
  background-color: #ff6e00;
}
.qrcode-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  .down-qr-btn {
    width: 180px;
    height: 30px;
    background: #ff7e00;
    border-radius: 6px;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    i {
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
    }
    span {
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
      margin-left: 10px;
    }
  }
  .copy-qr-btn {
    width: 180px;
    height: 30px;
    background: #fff3df;
    border-radius: 6px;
    border: 1px solid #ffbd7b;
    margin-top: 10px;
    display: flex;
    span {
      font-size: 12px;
      color: #666666;
      line-height: 28px;
      padding: 0 6px;
      overflow: hidden;
      flex: 1;
    }
    .copy {
      width: 40px;
      flex: inherit;
      background: #ff7e00;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .tip-txt {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/UIO/holidayWorkCharge/App.vue